export default "__VITE_ASSET__BpXkQw07__"